import React, {
    useMemo,
} from 'react';

import * as UTILS from "../utils";
import * as CONSTANTS from "../constants";

import ViewAlternativeDates from "./view-alternative-dates";

export default function InstanceEventSummary(props) {

    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(CONSTANTS.INSTANCE?.date);
    }, [CONSTANTS.INSTANCE?.date]);

    // console.log('DATE OF EVENT', formattedDate);

    return (
        <header className="instance-event-summary instance-event-summary__header">
            {CONSTANTS.EVENT.name ?
                <h1 className="instance-event-summary__title">{ CONSTANTS.EVENT.name }</h1>
            :null}
            {formattedDate ?
                <p className="instance-event-summary__date">{ formattedDate }</p>
            :null}
            {CONSTANTS.EVENT?.attributes[CONSTANTS.VENUE_ATTRIBUTE_NAME] ?
                <p className="instance-event-summary__venue">{ CONSTANTS.EVENT.attributes[CONSTANTS.VENUE_ATTRIBUTE_NAME] }</p>
            :null}

            {props.showAlternativeDates &&
                <ViewAlternativeDates selectedInstanceDate={CONSTANTS.INSTANCE.date} />
            }
        </header>
    );
}